// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper__1BUFJ","backButton":"PageWrapper_backButton__VvglD"};